/**
 * Logo / QR 叠加归一化配置(单一来源)—— 海报 + 视频成片编辑共用。
 *
 * 原在 `features/poster/api/posterTemplateService`(V6 fix4, 2026-05-12),
 * 2026-06-23 抽到 shared 供视频「成片编辑」面板跨 feature 复用(FSD:features 互不 import)。
 * posterTemplateService 仍 re-export 这三个符号,海报侧导入零改动。
 */

/** V6 fix4 (2026-05-12) — Logo / QR 在画布上的归一化位置 + 尺寸 + 旋转。 */
// local-only: backend schema gap — V6 OverlayConfig sub-type, sent in PATCH /assets/{id}/overlay
// and stored in xb_poster_template.schema_json. V24 yaml align.
export interface OverlayItem {
  x: number; // 0..1 左上角横坐标
  y: number; // 0..1
  w: number; // 0..1 宽度
  h: number; // 0..1 高度
  rotation?: number; // 仅 logo;0..360
}

/** logo + QR 叠加配置(模板默认 + 用户拖拽都用)。 */
// local-only: drift D-13 — V6 OverlayConfig (versioned bbox shape) coexists with generated
// v2.9 OverlayConfig (loose anchor-position shape) in posterService.ts; two shapes cover two
// distinct endpoints (PATCH /overlay vs PATCH /adjustment). V24 reconcile by giving each its
// own schema. See 2026-05-17-fe-drift-poster-task-status.md.
// local-only: drift D-37 (2026-05-18) — V37 加 4 个 brand override 字段。当 task 创建时未选
// brand,详情页用户临时挂载 logo / QR 时填这几个字段。backend 优先用 asset 级 override,
// fallback task.brand。详见 docs/contracts/v23/proposals/2026-05-18-asset-brand-override.md。
export interface OverlayConfig {
  version: 1;
  logo: OverlayItem | null;
  qr: OverlayItem | null;
  /** V37 — 临时挂载的 logo objectKey (xb_tenant_brand_assets.logos[].objectKey) */
  logoUploadId?: string | null;
  /** V37 — 临时挂载的 QR 模式 */
  qrCodeMode?: "UPLOAD" | "URL" | null;
  /** V37 — qrCodeMode=UPLOAD 时填 */
  qrCodeUploadId?: string | null;
  /** V37 — qrCodeMode=URL 时填(让 ai-service 用 qrcode lib 实时编码) */
  qrCodeUrl?: string | null;
  /** 1006 — 出图时已烙进画面的 logo 原位置(只作标记,合成不读;见 poster bakedOverlay.ts) */
  bakedLogo?: OverlayItem | null;
  /** 1006 — 出图时已烙进画面的二维码原位置(同上) */
  bakedQr?: OverlayItem | null;
}

export const DEFAULT_OVERLAY: OverlayConfig = {
  version: 1,
  logo: { x: 0.04, y: 0.04, w: 0.16, h: 0.16 },
  qr: { x: 0.78, y: 0.78, w: 0.18, h: 0.18 },
};
